

export default {
    async setPopupFlag(module) {
        const module_type = module + '_cyo_popup'
        this.commitMutation('setPopupFlag', module_type)
    },

}